export default "__VITE_ASSET__0dd2d9dd__"